import { tabCloser, tabTemplate, categoryTab } from '@/layout/state/state';
import { matchSingleUrl } from '@/constants/urls';
import { closeDictionaryMarkdown } from '../actions';
import DictionaryMarkdownActions from '../components/DictionaryMarkdownActions';
import DictionaryMarkdownPanel from '../components/DictionaryMarkdownPanel';

export default {
  ...tabTemplate(
    'dictionary-markdown',
    DictionaryMarkdownPanel,
    matchSingleUrl(['datasets', 'dictionaries', 'markdown']),
    DictionaryMarkdownActions,
  ),
  ...tabCloser('closeDictionaryMarkdownTab', closeDictionaryMarkdown),
  access: ({ datasets }, { isGuest }) => datasets.download && !isGuest,
  componentState: ({ args, url }) => (
    categoryTab(url, 'open', { code: decodeURIComponent(args[4]), datasetCode: decodeURIComponent(args[2]) })
  ),
  dropDownIcon: 'file outline',
  icon: 'far fa-file',
  order: 215,
};
